import { render } from "./CandidateSelectorModal.vue?vue&type=template&id=11f3cd2d"
import script from "./CandidateSelectorModal.vue?vue&type=script&lang=js"
export * from "./CandidateSelectorModal.vue?vue&type=script&lang=js"
script.render = render

export default script